import AboutSection from "components/About-Section";
import ContactSection from "components/Contact-Section";
import Footer from "components/Footer";
import HeroSection from "components/Hero-Section";
import WorkSection from "components/Work-Section";
import { motion } from "framer-motion";
const Home = () => {
  const navigationVariants = {
    initial: { y: "100vh" },
    animate: { y: "100vh" },
    exit: {
      y: ["100vh", "0vh", "0vh", "-100vh"],
      transition: { duration: 2, bounce: 0.3 },
    },
  };
  const navigationPageVariants = {
    initial: { x: 0 },
    exit: {
      x: "-100vw",
      transition: { duration: 0.5, bounce: 0, delay: 1 },
    },
  };
  return (
    <>
      <motion.div
        variants={navigationPageVariants}
        initial='initial'
        exit='exit'
        className={` w-screen  min-h-screen pt-[92px] relative z-[3]`}
      >
        <div className='md:container md:mx-auto px-6 md:px-0'>
          <HeroSection />
          <AboutSection />
          <WorkSection />
          <ContactSection />
          <Footer />
        </div>
      </motion.div>
      <motion.div
        variants={navigationVariants}
        initial='initial'
        animate='animate'
        exit='exit'
        className='bg-dark2 w-screen h-screen fixed top-0 left-0 z-[5] navigation-transition-container'
      ></motion.div>
    </>
  );
};

export default Home;
